import $ from "jquery";

export default class Landing {
  constructor(){
    this.config = {
      form: '#ajax-contact',
      formMessages: '#form-messages',
    }
  }

  sendEmail(){
    const form = $(this.config.form);
    const formMessages = $(this.config.formMessages);
      event.preventDefault();
      const formData = $(form).serialize();
      $.ajax({
        type: 'POST',
        url: $(form).attr('action'),
        data: formData
      })
      .done(function(response) {
        $(formMessages).removeClass('form__error');
        $(formMessages).addClass('form__success');
        $(formMessages).css({margin: '1rem 0', padding: '1rem'});
        // Set the message text.
        $(formMessages).text(response);
        // Clear the form.
        $('#name').val('');
        $('#email').val('');
        $('#message').val('');
    })
    .fail(function(data) {
      // Make sure that the formMessages div has the 'error' class.
      $(formMessages).removeClass('form__success');
      $(formMessages).addClass('form__error');
      // Set the message text.
      if (data.responseText !== '') {
          $(formMessages).text(data.responseText);
      } else {
          $(formMessages).text('Oops! An error occured and your message could not be sent.');
      }
    });
  }
}



// WEBPACK FOOTER //
// src/scripts/Contact.js